module.exports = __webpack_public_path__ + "static/media/control@2x.56e53ede.png";